namespace Cfnc {
    "use strict";

    interface ICfncMmenu extends ng.IDirective {
    }

    interface ICfncMmenuScope extends ng.IScope {
        menu: any;
    }

    declare const Mmenu: any;


    export class CfncMmenu implements ICfncMmenu {
        static directiveId: string = "cfncMmenu";
        restrict: string = "A";
        replace: boolean = false;       

        constructor() {

        }

        link = (scope: ICfncMmenuScope, element: ng.IAugmentedJQuery, attrs: any) => {
            scope.menu = new Mmenu(
                "#" + attrs.id,
                {
                    wrappers: ["angular"],
                    navbar: {
                        title: "Main Menu",
                    },
                    navbars: [
                        {
                            position: "top",
                            content: ["prev", "title"],
                        },
                    ],
                },
                {
                    // configuration
                    classNames: {
                        selected: "active",
                    },
                }
            );

        }

    }


    angular.module("app").directive(CfncMmenu.directiveId, [() => new CfncMmenu()]);
}